export default __webpack_public_path__ + "static/media/Puma.a24e855b.png";